// extracted by mini-css-extract-plugin
export var attribution = "_db-4";
export var authorName = "_db-5";
export var quote = "_db-3";
export var testimonial = "_db-2";
export var trustedBy = "_db-0";
export var trustedByLabel = "_db-1";